var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCommonApp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 3348,
    height: 2713,
    viewBox: "0 0 3348 2713",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_865",
    x: 257,
    y: 0,
    width: 3091,
    height: 2225,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 12,
    dy: -12,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.404,
    stopColor: "#fff",
    stopOpacity: 0.808
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_869",
    x: 16,
    y: 1461,
    width: 2647,
    height: 1252,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 8,
    dy: 8,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_866",
    x: 0,
    y: 1445,
    width: 2647,
    height: 1252,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: -8,
    dy: -8,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-3"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1505",
    "data-name": "Group 1505",
    transform: "translate(-5839 -7867)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1504",
    "data-name": "Group 1504"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1502",
    "data-name": "Group 1502"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 5839, 7867)",
    filter: "url(#Rectangle_865)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_865-2",
    "data-name": "Rectangle 865",
    width: 3070,
    height: 2204,
    rx: 30,
    transform: "translate(257 21)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("text", {
    id: "TESTING",
    transform: "translate(7631 8102)",
    fill: "#850138",
    fontSize: 72,
    fontFamily: "Arial-BoldMT, Arial",
    fontWeight: 700,
    letterSpacing: "-0.03em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -149.526,
    y: 0
  }, "TESTING")), /*#__PURE__*/React.createElement("line", {
    id: "Line_61",
    "data-name": "Line 61",
    x2: 2700,
    transform: "translate(6263.5 8230.5)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("text", {
    id: "SAT",
    transform: "translate(6324 8318)",
    fill: "#850138",
    fontSize: 64,
    fontFamily: "Arial-BoldMT, Arial",
    fontWeight: 700,
    letterSpacing: "-0.03em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -59.705,
    y: 0
  }, "SAT")), /*#__PURE__*/React.createElement("text", {
    id: "Critical_Reading",
    "data-name": "Critical Reading",
    transform: "translate(7180 8394)",
    fontSize: 55,
    fontFamily: "Arial-BoldMT, Arial",
    fontWeight: 700,
    letterSpacing: "-0.03em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -196.977,
    y: 0
  }, "Critical Reading")), /*#__PURE__*/React.createElement("text", {
    id: "_760",
    "data-name": 760,
    transform: "translate(7445 8394)",
    fontSize: 55,
    fontFamily: "ArialMT, Arial",
    letterSpacing: "-0.03em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -44.233,
    y: 0
  }, "760")), /*#__PURE__*/React.createElement("text", {
    id: "_06_01_2014",
    "data-name": "06/01/2014",
    transform: "translate(7113 8484)",
    fontSize: 55,
    fontFamily: "ArialMT, Arial",
    letterSpacing: "-0.03em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -130.209,
    y: 0
  }, "06/01/2014")), /*#__PURE__*/React.createElement("text", {
    id: "Taken",
    transform: "translate(7057 8574)",
    fontSize: 55,
    fontFamily: "Arial-BoldMT, Arial",
    fontWeight: 700,
    letterSpacing: "-0.03em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -74.138,
    y: 0
  }, "Taken")), /*#__PURE__*/React.createElement("text", {
    id: "_1",
    "data-name": 1,
    transform: "translate(7165 8574)",
    fontSize: 55,
    fontFamily: "ArialMT, Arial",
    letterSpacing: "-0.03em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -15.294,
    y: 0
  }, "1")), /*#__PURE__*/React.createElement("text", {
    id: "Math",
    transform: "translate(7826 8394)",
    fontSize: 55,
    fontFamily: "Arial-BoldMT, Arial",
    fontWeight: 700,
    letterSpacing: "-0.03em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -61.683,
    y: 0
  }, "Math")), /*#__PURE__*/React.createElement("text", {
    id: "_800",
    "data-name": 800,
    transform: "translate(7956 8394)",
    fontSize: 55,
    fontFamily: "ArialMT, Arial",
    letterSpacing: "-0.03em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -44.233,
    y: 0
  }, "800")), /*#__PURE__*/React.createElement("text", {
    id: "_06_01_2014-2",
    "data-name": "06/01/2014",
    transform: "translate(7894 8484)",
    fontSize: 55,
    fontFamily: "ArialMT, Arial",
    letterSpacing: "-0.03em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -130.209,
    y: 0
  }, "06/01/2014")), /*#__PURE__*/React.createElement("text", {
    id: "Planned",
    transform: "translate(7866 8574)",
    fontSize: 55,
    fontFamily: "Arial-BoldMT, Arial",
    fontWeight: 700,
    letterSpacing: "-0.03em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -102.015,
    y: 0
  }, "Planned")), /*#__PURE__*/React.createElement("text", {
    id: "Writing",
    transform: "translate(8504 8394)",
    fontSize: 55,
    fontFamily: "Arial-BoldMT, Arial",
    fontWeight: 700,
    letterSpacing: "-0.03em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -89.246,
    y: 0
  }, "Writing")), /*#__PURE__*/React.createElement("text", {
    id: "_770",
    "data-name": 770,
    transform: "translate(8661 8394)",
    fontSize: 55,
    fontFamily: "ArialMT, Arial",
    letterSpacing: "-0.03em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -44.233,
    y: 0
  }, "770")), /*#__PURE__*/React.createElement("text", {
    id: "_06_01_2014-3",
    "data-name": "06/01/2014",
    transform: "translate(8545 8484)",
    fontSize: 55,
    fontFamily: "ArialMT, Arial",
    letterSpacing: "-0.03em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -130.209,
    y: 0
  }, "06/01/2014")), /*#__PURE__*/React.createElement("line", {
    id: "Line_62",
    "data-name": "Line 62",
    x2: 2700,
    transform: "translate(6263.5 8832.5)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("text", {
    id: "SAT_SUBJECT_TESTS",
    "data-name": "SAT SUBJECT TESTS",
    transform: "translate(6581 8920)",
    fill: "#850138",
    fontSize: 64,
    fontFamily: "Arial-BoldMT, Arial",
    fontWeight: 700,
    letterSpacing: "-0.03em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -316.531,
    y: 0
  }, "SAT SUBJECT TESTS")), /*#__PURE__*/React.createElement("text", {
    id: "Math_Level_2",
    "data-name": "Math Level 2",
    transform: "translate(7139 9050)",
    fontSize: 55,
    fontFamily: "Arial-BoldMT, Arial",
    fontWeight: 700,
    letterSpacing: "-0.03em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -155.979,
    y: 0
  }, "Math Level 2")), /*#__PURE__*/React.createElement("text", {
    id: "Physics",
    transform: "translate(7082 9140)",
    fontSize: 55,
    fontFamily: "Arial-BoldMT, Arial",
    fontWeight: 700,
    letterSpacing: "-0.03em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -99.008,
    y: 0
  }, "Physics")), /*#__PURE__*/React.createElement("text", {
    id: "Chemistry",
    transform: "translate(7111 9230)",
    fontSize: 55,
    fontFamily: "Arial-BoldMT, Arial",
    fontWeight: 700,
    letterSpacing: "-0.03em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -127.892,
    y: 0
  }, "Chemistry")), /*#__PURE__*/React.createElement("text", {
    id: "_800-2",
    "data-name": 800,
    transform: "translate(7808 9050)",
    fontSize: 55,
    fontFamily: "ArialMT, Arial",
    letterSpacing: "-0.03em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -44.233,
    y: 0
  }, "800")), /*#__PURE__*/React.createElement("text", {
    id: "_800-3",
    "data-name": 800,
    transform: "translate(7808 9140)",
    fontSize: 55,
    fontFamily: "ArialMT, Arial",
    letterSpacing: "-0.03em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -44.233,
    y: 0
  }, "800")), /*#__PURE__*/React.createElement("text", {
    id: "_800-4",
    "data-name": 800,
    transform: "translate(7808 9230)",
    fontSize: 55,
    fontFamily: "ArialMT, Arial",
    letterSpacing: "-0.03em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -44.233,
    y: 0
  }, "800")), /*#__PURE__*/React.createElement("text", {
    id: "_05_02_2014",
    "data-name": "05/02/2014",
    transform: "translate(8244 9050)",
    fontSize: 55,
    fontFamily: "ArialMT, Arial",
    letterSpacing: "-0.03em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -130.209,
    y: 0
  }, "05/02/2014")), /*#__PURE__*/React.createElement("text", {
    id: "_05_02_2014-2",
    "data-name": "05/02/2014",
    transform: "translate(8244 9140)",
    fontSize: 55,
    fontFamily: "ArialMT, Arial",
    letterSpacing: "-0.03em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -130.209,
    y: 0
  }, "05/02/2014")), /*#__PURE__*/React.createElement("text", {
    id: "_05_02_2014-3",
    "data-name": "05/02/2014",
    transform: "translate(8244 9230)",
    fontSize: 55,
    fontFamily: "ArialMT, Arial",
    letterSpacing: "-0.03em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -130.209,
    y: 0
  }, "05/02/2014")), /*#__PURE__*/React.createElement("line", {
    id: "Line_63",
    "data-name": "Line 63",
    x2: 2700,
    transform: "translate(6263.5 9450)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("text", {
    id: "TOEFL_iBT",
    "data-name": "TOEFL iBT",
    transform: "translate(6419.5 9537.5)",
    fill: "#850138",
    fontSize: 64,
    fontFamily: "Arial-BoldMT, Arial",
    fontWeight: 700,
    letterSpacing: "-0.03em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -156.476,
    y: 0
  }, "TOEFL iBT")), /*#__PURE__*/React.createElement("text", {
    id: "Reading",
    transform: "translate(7087 9667)",
    fontSize: 55,
    fontFamily: "Arial-BoldMT, Arial",
    fontWeight: 700,
    letterSpacing: "-0.03em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -103.533,
    y: 0
  }, "Reading")), /*#__PURE__*/React.createElement("text", {
    id: "_29",
    "data-name": 29,
    transform: "translate(7243 9667.5)",
    fontSize: 55,
    fontFamily: "ArialMT, Arial",
    letterSpacing: "-0.03em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -29.763,
    y: 0
  }, "29")), /*#__PURE__*/React.createElement("text", {
    id: "_10_17_2014",
    "data-name": "10/17/2014",
    transform: "translate(7109 9757.5)",
    fontSize: 55,
    fontFamily: "ArialMT, Arial",
    letterSpacing: "-0.03em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -130.209,
    y: 0
  }, "10/17/2014")), /*#__PURE__*/React.createElement("text", {
    id: "Taken-2",
    "data-name": "Taken",
    transform: "translate(7057 9848)",
    fontSize: 55,
    fontFamily: "Arial-BoldMT, Arial",
    fontWeight: 700,
    letterSpacing: "-0.03em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -74.138,
    y: 0
  }, "Taken")), /*#__PURE__*/React.createElement("text", {
    id: "_1-2",
    "data-name": 1,
    transform: "translate(7165 9848)",
    fontSize: 55,
    fontFamily: "ArialMT, Arial",
    letterSpacing: "-0.03em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -15.294,
    y: 0
  }, "1")), /*#__PURE__*/React.createElement("text", {
    id: "Speaking",
    transform: "translate(7527 9668)",
    fontSize: 55,
    fontFamily: "Arial-BoldMT, Arial",
    fontWeight: 700,
    letterSpacing: "-0.03em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -116.485,
    y: 0
  }, "Speaking")), /*#__PURE__*/React.createElement("text", {
    id: "_26",
    "data-name": 26,
    transform: "translate(7695 9668)",
    fontSize: 55,
    fontFamily: "ArialMT, Arial",
    letterSpacing: "-0.03em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -29.763,
    y: 0
  }, "26")), /*#__PURE__*/React.createElement("text", {
    id: "_10_17_2014-2",
    "data-name": "10/17/2014",
    transform: "translate(7541 9757.5)",
    fontSize: 55,
    fontFamily: "ArialMT, Arial",
    letterSpacing: "-0.03em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -130.209,
    y: 0
  }, "10/17/2014")), /*#__PURE__*/React.createElement("text", {
    id: "Planned-2",
    "data-name": "Planned",
    transform: "translate(7965 9848)",
    fontSize: 55,
    fontFamily: "Arial-BoldMT, Arial",
    fontWeight: 700,
    letterSpacing: "-0.03em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -102.015,
    y: 0
  }, "Planned")), /*#__PURE__*/React.createElement("text", {
    id: "Listening",
    transform: "translate(7979 9668)",
    fontSize: 55,
    fontFamily: "Arial-BoldMT, Arial",
    fontWeight: 700,
    letterSpacing: "-0.03em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -115.619,
    y: 0
  }, "Listening")), /*#__PURE__*/React.createElement("text", {
    id: "_30",
    "data-name": 30,
    transform: "translate(8147 9668)",
    fontSize: 55,
    fontFamily: "ArialMT, Arial",
    letterSpacing: "-0.03em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -29.763,
    y: 0
  }, "30")), /*#__PURE__*/React.createElement("text", {
    id: "_10_17_2014-3",
    "data-name": "10/17/2014",
    transform: "translate(7993 9758)",
    fontSize: 55,
    fontFamily: "ArialMT, Arial",
    letterSpacing: "-0.03em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -130.209,
    y: 0
  }, "10/17/2014")), /*#__PURE__*/React.createElement("text", {
    id: "Writing-2",
    "data-name": "Writing",
    transform: "translate(8388 9668)",
    fontSize: 55,
    fontFamily: "Arial-BoldMT, Arial",
    fontWeight: 700,
    letterSpacing: "-0.03em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -89.246,
    y: 0
  }, "Writing")), /*#__PURE__*/React.createElement("text", {
    id: "_29-2",
    "data-name": 29,
    transform: "translate(8529 9667)",
    fontSize: 55,
    fontFamily: "ArialMT, Arial",
    letterSpacing: "-0.03em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -29.763,
    y: 0
  }, "29")), /*#__PURE__*/React.createElement("text", {
    id: "_10_17_2014-4",
    "data-name": "10/17/2014",
    transform: "translate(8425 9758)",
    fontSize: 55,
    fontFamily: "ArialMT, Arial",
    letterSpacing: "-0.03em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -130.209,
    y: 0
  }, "10/17/2014"))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_867",
    "data-name": "Rectangle 867",
    width: 2204,
    height: 677.426,
    transform: "translate(8991.048 7888) rotate(90)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1503",
    "data-name": "Group 1503",
    transform: "translate(-271 -1038.934)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 6110, 8905.93)",
    filter: "url(#Rectangle_869)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_869-2",
    "data-name": "Rectangle 869",
    width: 2629,
    height: 1234,
    rx: 30,
    transform: "translate(17 1462)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 6110, 8905.93)",
    filter: "url(#Rectangle_866)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_866-2",
    "data-name": "Rectangle 866",
    width: 2629,
    height: 1234,
    rx: 30,
    transform: "translate(17 1462)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("text", {
    id: "EDUCATION",
    transform: "translate(7472 10570.934)",
    fill: "#850138",
    fontSize: 61,
    fontFamily: "Arial-BoldMT, Arial",
    fontWeight: 700,
    letterSpacing: "-0.03em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -171.719,
    y: 0
  }, "EDUCATION")), /*#__PURE__*/React.createElement("line", {
    id: "Line_64",
    "data-name": "Line 64",
    x2: 2376.795,
    transform: "translate(6247.16 10704.183)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("text", {
    id: "HONORS",
    transform: "translate(6364.16 10780.15)",
    fill: "#850138",
    fontSize: 55,
    fontFamily: "Arial-BoldMT, Arial",
    fontWeight: 700,
    letterSpacing: "-0.03em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -116.577,
    y: 0
  }, "HONORS")), /*#__PURE__*/React.createElement("text", {
    id: "Google_Science_Fair_finalists_with_project_AI_based_solution_for_security_monitoring_Top24_out_of_4000_",
    "data-name": "Google Science Fair finalists with project \\u201CAI based solution for security monitoring\\u201D (Top24  out of 4000)",
    transform: "translate(6610 10928.934)",
    fontSize: 41,
    fontFamily: "Arial-BoldMT, Arial",
    fontWeight: 700,
    letterSpacing: "-0.03em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Google Science Fair finalists with project"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 41
  }, "\u201CAI based solution for security monitoring\u201D"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 82,
    xmlSpace: "preserve"
  }, "(Top24  out of 4000)")), /*#__PURE__*/React.createElement("text", {
    id: "International",
    transform: "translate(7773 10928.934)",
    fontSize: 41,
    fontFamily: "ArialMT, Arial",
    letterSpacing: "-0.03em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -105.45,
    y: 0
  }, "International")), /*#__PURE__*/React.createElement("text", {
    id: "_11",
    "data-name": 11,
    transform: "translate(8214 10929.934)",
    fontSize: 42,
    fontFamily: "ArialMT, Arial",
    letterSpacing: "-0.03em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -21.17,
    y: 0
  }, "11")), /*#__PURE__*/React.createElement("text", {
    id: "_2014_USAMO_Qualifier_top0.5_2013_AIME_Qualifier_Certificate_of_Distinction_in_AMC10_top1_",
    "data-name": "2014 USAMO Qualifier (top0.5%); 2013 AIME Qualifier, Certificate of Distinction in AMC10 (top1%)",
    transform: "translate(6610 11124.934)",
    fontSize: 41,
    fontFamily: "Arial-BoldMT, Arial",
    fontWeight: 700,
    letterSpacing: "-0.03em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "2014 USAMO Qualifier (top0.5%); 2013 AIME"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 41
  }, "Qualifier, Certificate of Distinction in AMC10"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 82
  }, "(top1%)")), /*#__PURE__*/React.createElement("text", {
    id: "National",
    transform: "translate(7737 11123.934)",
    fontSize: 40,
    fontFamily: "ArialMT, Arial",
    letterSpacing: "-0.03em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -69.179,
    y: 0
  }, "National")), /*#__PURE__*/React.createElement("text", {
    id: "_9_10_11",
    "data-name": "9, 10, 11",
    transform: "translate(8268 11125.934)",
    fontSize: 42,
    fontFamily: "ArialMT, Arial",
    letterSpacing: "-0.03em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -75.135,
    y: 0
  }, "9, 10, 11")), /*#__PURE__*/React.createElement("text", {
    id: "National_High_School_Mock_Trail_Championship_School_Debate_Club_Captain_state_tournament_qualifier_6th_out_of_344_",
    "data-name": "National High School Mock Trail Championship; School Debate Club Captain; state tournament qualifier (6th out of 344);",
    transform: "translate(6610 11319.934)",
    fontSize: 41,
    fontFamily: "Arial-BoldMT, Arial",
    fontWeight: 700,
    letterSpacing: "-0.03em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "National High School Mock Trail Championship;"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 41
  }, "School Debate Club Captain; state tournament"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 82
  }, "qualifier (6th out of 344);")), /*#__PURE__*/React.createElement("text", {
    id: "National-2",
    "data-name": "National",
    transform: "translate(7737 11318.934)",
    fontSize: 40,
    fontFamily: "ArialMT, Arial",
    letterSpacing: "-0.03em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -69.179,
    y: 0
  }, "National")), /*#__PURE__*/React.createElement("text", {
    id: "_10_11",
    "data-name": "10, 11",
    transform: "translate(8193 11321.934)",
    fontSize: 41,
    fontFamily: "ArialMT, Arial",
    letterSpacing: "-0.03em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "10, 11"))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommonApp);
export default __webpack_public_path__ + "static/media/commonApp.9c1631606c5308b186bd5ab5aa79fd66.svg";
export { ForwardRef as ReactComponent };